(function() {
    'use strict';

    angular
        .module('app')
        .directive('emailform', emailform);

    emailform.$inject = ['$window'];
    
    function emailform ($window) {
        // Usage:
        //     <emailform></emailform>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'E',
            templateUrl: 'app/emailform/templates/emailform.html',
            controller: 'emailform',
            controllerAs: 'vm',
            scope: {
                recipients: '=?',
                subject: '=?',
                body: '=?',
                bodyTemplate: '=?'
            }
        };
        return directive;

        function link(scope, element, attrs) {
            $(element).find(".email-body").click(function () {
                $(element).find("#editable-body").focus();
            });
        }
    }

})();